module.exports = __webpack_public_path__ + "static/img/30009 (3).20d8ad0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (3).webp
// module id = EZxX
// module chunks = 14